<form (submit)="onSubmit()">
  <gd-client-id-selector
    [showAllClientsOption]="true"
    [placeholder]="'txt_search_client_field_placeholder' | translate"
    [clientId]="clientId || null"
    (clientIdChange)="onChange($event)"
  >
  </gd-client-id-selector>
</form>
